import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager,
    Keyboard

} from "react-native"
import {typeExport} from "../../../../redux/store/type";
import {moderateScale} from "../../../../tools/Scaling";
import * as Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
import i18n from "../../../../I18n/i18n";
import {Tools} from "../../../../tools/Tools";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMAlert from "../../../../customviews/HMAlert";
import PathFile from "../../../../assets/PathFile";
import HMDialogWifiCheck from "../../../../customviews/HMDialogWifiCheck";
import wifi from "../../../../importCalss/wifi";
import HMIcon from "../../../../customviews/HMIcon";
import RNOtpVerify from 'react-native-otp-verify';
import HMListCheckBox from "../../../../customviews/HMListCheckBox";
import store from "../../../../redux/store";
import {callWebservice} from "../enterCode/action/ActionEnterCodeSatiaScreen";

let container = null;
let HashCode = null;
export default class LoginEnterPhoneCodeSatiaScreen extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            mobile: '',
            otp: null,
            indexSelectCheckBoxType: 1,
            time: 120,
            seconds: 120,
            count: 120,
            countCall: 1,
        }

    }


    componentWillReceiveProps(props) {


    }


    getData() {

        if (this.props.DataSplashScreen.Connection) {
            let {mobile, code} = this.state;
            global._mobile = mobile
            //let checkTypeLogin = this.props.route.params && this.props.route.params.type == "forgot_my_password";
            this.setState({
                    Once: true
                },
                () => {

                    // "lang": i18n.locale,
                    //     "username": Tools.persianToEnglish(this.props.route.params.mobile),
                    //     "password": Tools.persianToEnglish(this.state.code),
                    //     "token_fb": this.props.DataSplashScreen.token_fb,
                    let paramss = {
                        "lang": i18n.locale,
                        "username": mobile,
                        "password": code,
                        "HashCode": HashCode,
                        "token_fb": this.props.DataSplashScreen.token_fb,
                        "indexSelectCheckBoxType": this.state.indexSelectCheckBoxType,
                    };

                    store.dispatch(callWebservice(
                        null,
                        typeExport._baseUrlSatia + (this.state.indexSelectCheckBoxType === 1 ? "user/login" : "user/loginUserName"),
                        paramss,
                        typeExport.TypegetDataEnterCodeSatiaScreen,
                        "POST"
                    ))
                    /*  this.props.callService(
                          // typeExport._baseUrlSatia + "user/sendcode",
                          typeExport._baseUrlSatia + "user/sendcode",
                          paramss,
                          typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                          "POST",
                          this.state
                      );*/
                }
            )

        } else
            this.props.callServiceError("offline")


    }

    checkMobile(text, func, type) {
        if (!(text && text.trim().length !== 0)) {

            HMAlert(
                i18n.t('constant.message'),
                this.state.indexSelectCheckBoxType == 1 ? i18n.t('constant.checkMobile') : "نام کاربری را وارد نمایید",
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            return true;
        }
        if (type && !(this.state.code && this.state.code.trim().length !== 0)) {
            HMAlert(
                i18n.t('constant.message'),
                this.state.indexSelectCheckBoxType == 1 ? "رمز عبور وارد نمایید" : "کلمه عبور را وارد نمایید",
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            );
            return true;
        }

        text = Tools.persianToEnglish(text)

        const reg = /^([0]|| [98])?09\d{9}$/;
        if (reg.test(text) === false && this.state.indexSelectCheckBoxType == 1) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkMobile'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        }
        else {
            func ? func() : this.getData();
            /*  if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length <= 3) {
                  HMAlert(
                      i18n.t('constant.message'),
                      i18n.t('constant.checkPassword'),
                      [
                          // {text: 'Ask me later', onPress: () => {}},
                          // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                          {text: i18n.t('constant.ok'), onPress: () => {}},
                      ],
                      {cancelable: true}
                  )
                  //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

              } else {
                  //  this.loadingButton.showLoading(true);
                  this.setState({
                          // mobile: text,
                      }
                      ,
                      () => {
                          this.getData()
                      }
                  );

              }*/

        }

    }

///////// SMS ///////
    // Actions
    getHash = () =>
        RNOtpVerify.getHash()
            .then((data) => {
                HashCode = data;
            })
            .catch(console.log);


/////////
    componentDidMount() {
        if (Platform.OS === "android") {

            this.getHash()
        }


        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {mobile, code} = this.state;

        let checkCallCode = !(this.state.seconds < 1 || (this.state.countCall <= 1));


        return (
            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>
                <View style={{flex: 1,}}>

                    <View
                        style={{
                            flex: .18,
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: Colors.colorPrimary
                        }}
                    >
                        {/*    <HMTextView
                            style={{
                                color: "#fff",
                                fontSize: moderateScale(34),
                                //fontSize:moderateScale(16)
                            }}
                            text={i18n.t('appName')}
                            type={"bold"}
                        />*/}

                        <Image

                            //resizeMode={"stretch"}
                            style={{
                                width: moderateScale(80),
                                height: moderateScale(42),

                                //position: 'absolute',
                                //borderRadius: 50),
                                //     backgroundColor: Colors.white


                            }}
                            // source={require('../../../assets/img/logo.png')}
                            source={PathFile.image.name_satia}
                            //source={{uri: "https://painrelief-blog.org/wp-content/uploads/2019/07/5d2233166143e.jpg"}}
                        />

                    </View>

                    <View style={{
                        flex: .82,
                        padding: moderateScale(14),
                        //backgroundColor:"#ee0038"
                    }}>
                        {/*             <HMTextView
                  style={{
                      //fontSize:moderateScale(16)
                  }}
                  text={"ساتیا"}
                  type={"bold"}
              />*/}


                        {/* <HMRadioButton
                            data={[
                                {
                                    label: 'data 1'
                                },
                                {
                                    label: 'data 2'
                                }
                            ]}
                            selectedBtn={(e) => console.log(e)}
                            icon={
                                <HMIcon
                                    name="check-circle"
                                    size={25}
                                    color={"#2c9dd1"}
                                />
                            }
                        />*/}
                        <View style={{width: "100%"}}>
                            <HMListCheckBox
                                data={{
                                    list: [
                                        {id: 1, name: "شماره موبایل"},
                                        {id: 2, name: "نام کاربری و کلمه عبور"},

                                    ],
                                    indexSelect: this.state['indexSelectCheckBoxType'],
                                    name: 'Type',

                                }}
                                onPress={
                                    this.onPressSelectCheckBox
                                }

                            />
                        </View>
                        <HMTextInput
                           // _ref={(ref) => this.valueRef = ref}
                            onRef={(ref) => { this.valueRef = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            title={this.state.indexSelectCheckBoxType == 1 ? "شماره موبایل" : "نام کاربری"}
                            placeholder={(this.state.indexSelectCheckBoxType == 1 ? "شماره موبایل" : "نام کاربری") + " را وارد نمایید"}
                            // title={'constant.phoneNumber'}
                            // placeholder={'constant.PH_phoneNumber'}
                            // lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("mobile", text)}
                            onSubmitEditing={() => {
                                //  this.checkMobile(this.state.mobile)
                            }}
                            // onPressClear={() => this.onChangeText("value", null)}
                            onPressClear={() => {
                                this.onChangeText("mobile", null)
                                this.valueRef.clear()
                            }}
                            value={mobile}
                            keyboardType="numeric"
                        />
                        <HMTextInput
                            //_ref={(ref) => this.valueRefPass = ref}
                            onRef={(ref) => { this.valueRefPass = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            //  title={'constant.descCode'}
                            title={this.state.indexSelectCheckBoxType == 1 ? "رمز عبور" : "کلمه عبور"}
                            placeholder={(this.state.indexSelectCheckBoxType == 1 ? "رمز عبور" : "کلمه عبور") + " را وارد نمایید"}

                            // noLangTitle
                            //  placeholder={i18n.t('constant.password')}

                            //lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("code", text)}
                            onSubmitEditing={() => {
                                this.checkMobile(this.state.mobile)
                            }}
                            // onPressClear={() => this.onChangeText("code", null)}
                            onPressClear={() => {
                                this.onChangeText("code", null)
                                this.valueRefPass.clear()
                            }}
                            value={code}
                            keyboardType={"numeric"}
                            secureTextEntry={true}
                        />
                        {
                            this.state.indexSelectCheckBoxType == 1 ?
                                <View
                                    style={{
                                        width: "100%",
                                        // height: moderateScale(100),
                                        alignItems: "center",
                                        marginTop: moderateScale(15)
                                    }}>
                                    <View style={{flexDirection: "row"}}>
                                        <HMTextView
                                            type="bold"
                                            style={{
                                                // alignSelf: "center",
                                                color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                fontSize: moderateScale(14),
                                                //    textAlign: 'center'

                                            }}
                                            _children
                                            styleRoot={{
                                                flexDirection: 'column',
                                                flex: 1,
                                                // justifyContent: "flex-end",
                                                flexWrap: 'wrap',
                                                //    alignItems: 'center', justifyContent: 'center'
                                            }}
                                        >

                                            {"بازیابی کلمه عبور از طریق: "}
                                        </HMTextView>
                                        {
                                            this.state.seconds < this.state.time &&
                                            <HMTextView
                                                text={"( زمان باقی مانده : " + Tools.getTimeStringM(this.state.seconds) + ")"}
                                                type="bold"
                                                style={{
                                                    alignSelf: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center'

                                                }}/>
                                        }
                                    </View>
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            width: "100%",
                                            flexWrap: 'wrap',
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // backgroundColor: "#5ad5ee"
                                        }}>


                                        <TouchableOpacity

                                            onPress={() => {
                                                this.checkMobile(this.state.mobile, () => {
                                                    let paramss = {
                                                        "lang": i18n.locale,
                                                        "mobile": this.state.mobile,
                                                        // "type": "email",
                                                        "retry": true,
                                                    };


                                                    container.props.callService(
                                                        // typeExport._baseUrlSatia + "user/sendcode",
                                                        typeExport._baseUrlSatia + "user/sendcode",
                                                        paramss,
                                                        typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                                        "POST",
                                                        this.state,
                                                        this.retryTime
                                                    )
                                                })


                                            }}
                                            disabled={checkCallCode}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: 'row-reverse',
                                                    alignItems: 'center', justifyContent: 'center',
                                                    borderRadius: moderateScale(4),
                                                    borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                                    padding: moderateScale(4),
                                                    borderWidth: moderateScale(1),
                                                    // marginTop: moderateScale(4),
                                                    marginHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(4),
                                                    width: moderateScale(80),
                                                    height: moderateScale(50),

                                                    //  alignSelf: "center"

                                                }}
                                            >
                                                <HMIcon
                                                    type={"MaterialCommunityIcons"}
                                                    name={"email-outline"}
                                                    style={{
                                                        color: !checkCallCode ? Colors.blue : Colors.gray,
                                                        fontSize: moderateScale(24)
                                                    }}/>
                                            </View>
                                            <View style={{
                                                flex: 1,
                                                flexDirection: "row",
                                                paddingHorizontal: moderateScale(4),
                                                alignSelf: "center",

                                                // flexDirection: 'column',
                                                // flex: 1,
                                                // justifyContent: "flex-end",
                                                //   flexWrap: 'wrap',
                                                //    alignItems: 'center', justifyContent: 'center'

                                            }}>
                                                <HMTextView
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                        fontSize: moderateScale(13),
                                                        //    textAlign: 'center'

                                                    }}
                                                    _children
                                                    styleRoot={{
                                                        flexDirection: 'column',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        //    alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                >

                                                    {"پیامک"}
                                                </HMTextView>
                                                {/*<HMTextView
                                    type="bold"
                                    style={{
                                        // alignSelf: "center",
                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                        fontSize: moderateScale(14),
                                        //    textAlign: 'center'

                                    }}
                                    _children
                                    styleRoot={{
                                        flexDirection: 'column',
                                        flex: 1,
                                        // justifyContent: "flex-end",
                                        flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    درصورتی که
                                    <Text style={{
                                        color: !checkCallCode ? Colors.red : Colors.colorDark,
                                        marginHorizontal: moderateScale(6)
                                    }}>
                                        کد ورود
                                    </Text>
                                    را دریافت نکردید کلیک نمایید تا از طریق تماس تلفنی کد برای شما خوانده شود
                                </HMTextView>*/}

                                            </View>

                                        </TouchableOpacity>

                                        <TouchableOpacity
                                            // style={{
                                            //     flexDirection: 'row-reverse',
                                            //     alignItems: 'center', justifyContent: 'center',
                                            //     borderRadius: moderateScale(4),
                                            //     borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                            //     padding: moderateScale(4),
                                            //     borderWidth: moderateScale(1),
                                            //     // marginTop: moderateScale(4),
                                            //     marginHorizontal: moderateScale(4),
                                            //     marginVertical: moderateScale(4),
                                            //     width: moderateScale(200),
                                            //     height: moderateScale(60),
                                            //     //  alignSelf: "center"
                                            //
                                            // }}
                                            onPress={() => {

                                                this.checkMobile(this.state.mobile, () => {
                                                    let paramss = {
                                                        "lang": i18n.locale,
                                                        "mobile": this.state.mobile,
                                                        "type": "mobile",
                                                        "retry": true,
                                                    };


                                                    container.props.callService(
                                                        // typeExport._baseUrlSatia + "user/sendcode",
                                                        typeExport._baseUrlSatia + "user/sendcode",
                                                        paramss,
                                                        typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                                        "POST",
                                                        this.state,
                                                        this.retryTime
                                                    )
                                                })


                                            }}
                                            disabled={checkCallCode}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: 'row-reverse',
                                                    alignItems: 'center', justifyContent: 'center',
                                                    borderRadius: moderateScale(4),
                                                    borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                                    padding: moderateScale(4),
                                                    borderWidth: moderateScale(1),
                                                    // marginTop: moderateScale(4),
                                                    marginHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(4),
                                                    width: moderateScale(80),
                                                    height: moderateScale(50),

                                                    //  alignSelf: "center"

                                                }}
                                            >
                                                <HMIcon
                                                    type={"MaterialIcons"}
                                                    name={"phonelink-ring"}
                                                    style={{
                                                        color: !checkCallCode ? Colors.blue : Colors.gray,
                                                        fontSize: moderateScale(24)
                                                    }}/>
                                            </View>
                                            <View style={{
                                                flex: 1,
                                                flexDirection: "row",
                                                paddingHorizontal: moderateScale(4),
                                                alignSelf: "center"
                                                // flexDirection: 'column',
                                                // flex: 1,
                                                // justifyContent: "flex-end",
                                                //   flexWrap: 'wrap',
                                                //    alignItems: 'center', justifyContent: 'center'

                                            }}>
                                                <HMTextView
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                        fontSize: moderateScale(13),
                                                        //    textAlign: 'center'

                                                    }}
                                                    _children
                                                    styleRoot={{
                                                        flexDirection: 'column',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        //    alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                >

                                                    تماس موبایل
                                                </HMTextView>


                                            </View>

                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            // style={{
                                            //     flexDirection: 'row-reverse',
                                            //     alignItems: 'center', justifyContent: 'center',
                                            //     borderRadius: moderateScale(4),
                                            //     borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                            //     padding: moderateScale(4),
                                            //     borderWidth: moderateScale(1),
                                            //     // marginTop: moderateScale(4),
                                            //     marginHorizontal: moderateScale(4),
                                            //     marginVertical: moderateScale(4),
                                            //     width: moderateScale(200),
                                            //     height: moderateScale(60),
                                            //     //  alignSelf: "center"
                                            //
                                            // }}
                                            onPress={() => {


                                                this.checkMobile(this.state.mobile, () => {
                                                    let paramss = {
                                                        "lang": i18n.locale,
                                                        "mobile": this.state.mobile,
                                                        "type": "phone",
                                                        "retry": true,
                                                    };


                                                    container.props.callService(
                                                        // typeExport._baseUrlSatia + "user/sendcode",
                                                        typeExport._baseUrlSatia + "user/sendcode",
                                                        paramss,
                                                        typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                                        "POST",
                                                        this.state,
                                                        this.retryTime
                                                    )
                                                })

                                            }}
                                            disabled={checkCallCode}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: 'row-reverse',
                                                    alignItems: 'center', justifyContent: 'center',
                                                    borderRadius: moderateScale(4),
                                                    borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                                    padding: moderateScale(4),
                                                    borderWidth: moderateScale(1),
                                                    // marginTop: moderateScale(4),
                                                    marginHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(4),
                                                    width: moderateScale(80),
                                                    height: moderateScale(50),

                                                    //  alignSelf: "center"

                                                }}
                                            >
                                                <HMIcon
                                                    type={"Feather"}
                                                    name={"phone-call"}
                                                    style={{
                                                        color: !checkCallCode ? Colors.blue : Colors.gray,
                                                        fontSize: moderateScale(24)
                                                    }}/>
                                            </View>
                                            <View style={{
                                                flex: 1,
                                                flexDirection: "row",
                                                paddingHorizontal: moderateScale(4),
                                                alignSelf: "center"
                                                // flexDirection: 'column',
                                                // flex: 1,
                                                // justifyContent: "flex-end",
                                                //   flexWrap: 'wrap',
                                                //    alignItems: 'center', justifyContent: 'center'

                                            }}>
                                                <HMTextView
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                        fontSize: moderateScale(13),
                                                        //    textAlign: 'center'

                                                    }}
                                                    _children
                                                    styleRoot={{
                                                        flexDirection: 'column',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        //    alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                >

                                                    تماس تلفن
                                                </HMTextView>


                                            </View>

                                        </TouchableOpacity>


                                        {
                                            <TouchableOpacity

                                                onPress={() => {


                                                    this.checkMobile(this.state.mobile, () => {
                                                        let paramss = {
                                                            "lang": i18n.locale,
                                                            "mobile": this.state.mobile,
                                                            "type": "email",
                                                            "retry": true,
                                                        };


                                                        container.props.callService(
                                                            // typeExport._baseUrlSatia + "user/sendcode",
                                                            typeExport._baseUrlSatia + "user/sendcode",
                                                            paramss,
                                                            typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                                            "POST",
                                                            this.state,
                                                            this.retryTime
                                                        )
                                                    })
                                                }}
                                                disabled={checkCallCode}
                                            >
                                                <View
                                                    style={{
                                                        flexDirection: 'row-reverse',
                                                        alignItems: 'center', justifyContent: 'center',
                                                        borderRadius: moderateScale(4),
                                                        borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                                        padding: moderateScale(4),
                                                        borderWidth: moderateScale(1),
                                                        // marginTop: moderateScale(4),
                                                        marginHorizontal: moderateScale(2),
                                                        marginVertical: moderateScale(4),
                                                        width: moderateScale(80),
                                                        height: moderateScale(50),

                                                        //  alignSelf: "center"

                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"Entypo"}
                                                        name={"email"}
                                                        style={{
                                                            color: !checkCallCode ? Colors.blue : Colors.gray,
                                                            fontSize: moderateScale(24)
                                                        }}/>
                                                </View>
                                                <View style={{
                                                    flex: 1,
                                                    flexDirection: "row",
                                                    paddingHorizontal: moderateScale(4),
                                                    alignSelf: "center",

                                                    // flexDirection: 'column',
                                                    // flex: 1,
                                                    // justifyContent: "flex-end",
                                                    //   flexWrap: 'wrap',
                                                    //    alignItems: 'center', justifyContent: 'center'

                                                }}>
                                                    <HMTextView
                                                        type="bold"
                                                        style={{
                                                            alignSelf: "center",
                                                            color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                            fontSize: moderateScale(13),
                                                            //    textAlign: 'center'

                                                        }}
                                                        _children
                                                        styleRoot={{
                                                            flexDirection: 'column',
                                                            flex: 1,
                                                            // justifyContent: "flex-end",
                                                            flexWrap: 'wrap',
                                                            //    alignItems: 'center', justifyContent: 'center'
                                                        }}
                                                    >

                                                        {"ایمیل"}
                                                    </HMTextView>
                                                    {/*<HMTextView
                                    type="bold"
                                    style={{
                                        // alignSelf: "center",
                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                        fontSize: moderateScale(13),
                                        //    textAlign: 'center'

                                    }}
                                    _children
                                    styleRoot={{
                                        flexDirection: 'column',
                                        flex: 1,
                                        // justifyContent: "flex-end",
                                        flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    درصورتی که
                                    <Text style={{
                                        color: !checkCallCode ? Colors.red : Colors.colorDark,
                                        marginHorizontal: moderateScale(6)
                                    }}>
                                        کد ورود
                                    </Text>
                                    را دریافت نکردید کلیک نمایید تا از طریق تماس تلفنی کد برای شما خوانده شود
                                </HMTextView>*/}

                                                </View>

                                            </TouchableOpacity>
                                        }
                                        {/*      <View style={{
                                flexDirection: 'row-reverse',
                                alignItems: 'center', justifyContent: 'center',
                                //borderRadius: moderateScale(4),
                                // borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                padding: moderateScale(4),
                                // borderWidth: moderateScale(1),
                                marginTop: moderateScale(4),
                                width: moderateScale(200),
                                height: moderateScale(60),
                                marginHorizontal: moderateScale(4),
                                alignSelf: "center"

                            }}/>*/}

                                    </View>

                                </View>
                                :
                                null
                        }

                        <View
                            style={{
                                width: '100%',
                                //flexDirection: "row",
                                alignItems: 'center',
                                justifyContent: 'center',


                            }}>
                            {/*  <TouchableOpacity
                                style={{
                                    //    width: moderateScale(120),
                                    // height: moderateScale(40),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(10),
                                    //  backgroundColor: Colors.colorPrimary,
                                    //  borderRadius: moderateScale(6),
                                }}
                                onPress={() => {
                                    //    NavigationService.navigate('EnterCodeSatiaScreen', { userName: 'Lucy' });
                                    if (Platform.OS === "web")
                                        NavigationService.navigateParams("InformationSatiaScreen")
                                    else
                                        Tools.GoLink("https://app.satia.co/r")
                                    //this.checkMobile(this.state.mobile)
                                }}
                            >
                                <HMTextView
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blue
                                    }}
                                    text={"ثبت اشتراک جدید"}
                                    //lang
                                    type={"bold"}
                                />
                            </TouchableOpacity>*/}

                            <TouchableOpacity
                                style={{
                                    width: moderateScale(300),
                                    height: moderateScale(40),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(6),
                                    backgroundColor: Colors.colorPrimary,
                                    borderRadius: moderateScale(6),
                                }}
                                onPress={() => {
                                    //    NavigationService.navigate('EnterCodeSatiaScreen', { userName: 'Lucy' });

                                    //    NavigationService.navigateParams("InformationSatiaScreen")
                                    this.checkMobile(this.state.mobile, null, 'login')
                                }}
                            >
                                <HMTextView
                                    style={{
                                        //fontSize:moderateScale(16)
                                    }}
                                    // text={"constant.NextLevel"}
                                    text={"constant.Login"}
                                    lang
                                    type={"bold"}
                                />
                            </TouchableOpacity>

                        </View>
                        {
                            Platform.OS === "android" ?

                                // WiFiReview && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                                <TouchableOpacity


                                    style={{
                                        width: '50%',
                                        backgroundColor: Colors.colorPrimary,
                                        // height:moderateScale(40),
                                        padding: moderateScale(10),
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(6),
                                        borderRadius: moderateScale(8),
                                        alignSelf: 'center',
                                    }}
                                    onPress={() => {
                                        this.setState({
                                            WifiCheck: true
                                        })
                                    }}
                                >
                                    <View style={{flexDirection: "row", alignSelf: 'center',}}>
                                        <HMIcon name={"wifi"}
                                            // type={"FontAwesome"}
                                                style={{
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.white,
                                                    width: moderateScale(29),
                                                    height: moderateScale(29),
                                                    fontSize: moderateScale(24)
                                                }}/>
                                        <View style={{width: moderateScale(10)}}/>
                                        <HMTextView
                                            type={"bold"}
                                            //text={i18n.t('constant.WiFiReview')}
                                            text={"اتصال با هات اسپات"}
                                            style={{color: "white", fontSize: moderateScale(14)}}
                                        />

                                    </View>
                                </TouchableOpacity>

                                :
                                null
                        }
                        {/*           <TouchableOpacity
                            style={{
                                //    width: moderateScale(120),
                                // height: moderateScale(40),
                                //alignItems: 'center',
                                //justifyContent: 'center',
                                marginVertical: moderateScale(6),
                                marginHorizontal: moderateScale(10),
                                //  backgroundColor: Colors.colorPrimary,
                                //  borderRadius: moderateScale(6),
                            }}
                            onPress={() => {
                                //    NavigationService.navigate('EnterCodeSatiaScreen', { userName: 'Lucy' });

                                NavigationService.navigateParams("LoginEnterUsernameSatiaScreen")

                            }}
                        >
                            <HMTextView
                                style={{
                                    fontSize: moderateScale(12),
                                    color: Colors.blue
                                }}
                                text={"ورود با رمز عبور"}
                                //lang
                                type={"bold"}
                            />
                        </TouchableOpacity>*/}

                    </View>
                    {
                        this.state.WifiCheck ?
                            // !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                            <HMDialogWifiCheck onPressCancel={() => {
                                this.setState({
                                    WifiCheck: false
                                })
                            }} func={null
                                //this.checkMobile
                            }/>
                            : null
                    }
                    {
                        this.props.NoInternetDialog ?
                            <DialogConnectionCustomize
                                again
                                // WiFiReview={this.state.showButtonWifi}
                                //
                                // // showButtonWifi={()=>{showButtonWifi:false}}
                                // onPressWiFiReview={async () => {
                                //     this.setState({
                                //         WifiCheck: true
                                //     })
                                // }}
                                //   onPress={() => this.checkMobile(this.state.mobile)}
                                // onPress={() => {
                                //     this.props.callServiceRefresh()
                                // }}
                            />
                            :
                            null
                    }
                    {
                        this.props.NoInternetDialog ?
                            <DialogConnectionCustomize
                                onPress={() => this.checkMobile(this.state.mobile)}
                            />
                            :
                            null
                    }

                    {
                        this.props.isLoading || this.props.isLoadingLogin ?
                            <DialogLoadingCustomize/>
                            : null
                    }

                </View>
            </KeyboardAvoidingView>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
            },
            () => {
            })
    }

    onChangeText(name, text) {
        this.setState({[name]: text});
    }


    retryTime() {


        if (container.timeout) {
            clearInterval(container.timeout);
        }
        container.setState({
                seconds: container.state.time,
                countCall: container.state.countCall + 1,
            },
            () => {
                container.timeout = setInterval(() => {
                    if (container.state.seconds < 1) {

                        // container.setState({
                        //         countCall: 1,
                        //     },
                        // )
                        /*    this.setState({

                            })*/
                        //   this.props.navigation.pop();
                    }
                    else
                        container.setState({
                            seconds: container.state.seconds - 1
                        })
                }, 1000);
            }
        )

    }
}
